import img100 from '../images/LeetCode100.gif';
import img50 from '../images/LeetCode50.gif';
import imgSQL from '../images/LeetCodeSQL.gif';
import imgPandas from '../images/LeetCodePandas.gif';
import imgApr from '../images/LeetCodeApr.gif';
import imgMar from '../images/LeetCodeMar.gif';
import imgFeb from '../images/LeetCodeFeb.gif';
import imgMay from '../images/leetcodeMay.gif';
import imgJune from '../images/LeetCodeJune.gif';
import imgJuly from '../images/LeetCodeJuly.gif';
import imgAug from '../images/LeetCodeAug.gif';
import imgSep from '../images/LeetCodeSept.gif';
import imgOct from '../images/LeetCodeOct.gif';
import imgNov from '../images/LeetCodeNov.gif';
import imgDec from '../images/LeetCodeDec.gif';
import img200 from '../images/LeetCode200.gif';
import img365 from '../images/LeetCode365.gif';
import img2024 from '../images/LeetCode2024.gif';
import imgJan25 from '../images/Leet25Jan.gif';
import img50days2025 from '../images/leetcode2025_50.gif';

const testimonials = [
  {
    id: 1,
    name: '365 Days Badge',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: img365,
  },
  {
    id: 2,
    name: 'Annual Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: img2024,
  },
  {
    id: 3,
    name: '50 Days Badge 2025',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: img50days2025,
  },
  {
    id: 3,
    name: '200 Days Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: img200,
  },
  {
    id: 4,
    name: '100 Days Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: img100,
  },
  {
    id: 5,
    name: '50 Days Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: img50,
  },
  {
    id: 6,
    name: 'Top SQL 50',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgSQL,
  },
  {
    id: 7,
    name: 'Introduction to Pandas',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgPandas,
  },
  {
    id: 8,
    name: 'February LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgFeb,
  },
  {
    id: 9,
    name: 'March LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgMar,
  },
  {
    id: 10,
    name: 'April LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgApr,
  },
  {
    id: 11,
    name: 'May LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgMay,
  },
  {
    id: 12,
    name: 'June LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgJune,
  },
  {
    id: 13,
    name: 'July LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgJuly,
  },
  {
    id: 14,
    name: 'August LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgAug,
  },
  {
    id: 15,
    name: 'September LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgSep,
  },
  {
    id: 16,
    name: 'October LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgOct,
  },
  {
    id: 17,
    name: 'November LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgNov,
  },
  {
    id: 18,
    name: 'December LeetCode Badge 2024',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgDec,
  },
  {
    id: 19,
    name: 'January LeetCode Badge 2025',
    title: 'LeetCode ID: ',
    org: 'valar_morghulis_21',
    desc: imgJan25,
  },
];
export default testimonials;
